import { Batch } from '@/models/Batch';
import { BatchDivision } from '@/models/BatchDivision';
import { Shed } from '@/models/Shed';

export const getters = {
  getShedsEnthalpyCount(state) {
    return state.shedsEnthalpyCount;
  },

  getSheds(state) {
    return state.sheds;
  },

  getPcpSheds(state) {
    return state.pcpSheds;
  },

  getTotalSheds(state) {
    return state.totalSheds;
  },

  getShedsIsLoaded(state) {
    return state.shedsIsLoaded;
  },

  getSingleShed(state) {
    return state.singleProperty;
  },

  getSelectedShed(state) {
    return Shed.fromStore(state.selectedShed);
  },

  getSelectedShedAmbientance(state) {
    return state.selectedShedAmbientance;
  },

  getSelectedShedAmbientanceFull(state) {
    return state.selectedShedAmbientanceFull;
  },

  getRationPrediction(state) {
    return state.rationPrediction;
  },

  getSelectedBatch(state) {
    return Batch.fromStore(state.selectedBatch);
  },

  getSelectedBatchDivision(state) {
    return BatchDivision.fromStore(state.selectedBatchDivision);
  },

  getSelectedBatchDivisions(state) {
    return state.selectedBatchDivisions.map((b) => BatchDivision.fromStore(b));
  },

  getDashboardsSettings(state) {
    return state.dashboards;
  },

  getLoadedBatchId(state) {
    return state.loadedBatchId;
  },

  getLineages(state) {
    return state.lineages;
  },

  getSexes(state) {
    return state.sexes;
  },

  getProductionTypes(state) {
    return state.productionType;
  },

  getBreedingTypes(state) {
    return state.breedingType;
  },

  getMortality(state) {
    return state.mortality;
  },
};
